module.exports = __webpack_public_path__ + "img/牡羊座.a43ac1b1.svg";